import { Button, message, Modal, Space, Table } from "antd";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import EUtils, { IButtonConfig } from "../../../utils/EUtils";
import { ExclamationCircleFilled, LineOutlined } from '@ant-design/icons';
import ComparisonProductPriceEdit from "./ComparisonProductPriceEdit";
import { ColumnsType } from "antd/lib/table";
const { confirm } = Modal;

interface IComparisonProductPrice {
    viewMode: number;
    data: any;
}

const ComparisonProductPrice = forwardRef((props: IComparisonProductPrice, ref: any) => {
    const { viewMode, data } = props;
    const [dataSource, setDataSource] = useState<any[]>([]);
    const [editRecord, setEditRecord] = useState<any>({});

    const refComparisonProductPriceEdit = useRef<any>(null);

    useImperativeHandle(ref, () => ({
        setData: (value: any) => {
            setDataSource(value);
        },
        getData: () => {
            return dataSource;
        },
    }));

    const columns: ColumnsType<any> = [
        {
            key: 'revenue', title: '营业额', dataIndex: 'revenue'
            , fixed: 'left', ellipsis: true, width: 160,
            render(value: any, record: any, index: any) {
                return <a onClick={() => {
                    onEdit(record, index, 2);
                }}>{value}</a>
            },
        },
        { key: 'singleLimit', title: '单次限额（万元）', dataIndex: 'singleLimit', width: 150, align: 'right', ellipsis: true },
        {
            key: 'insuranceAmount', title: '保费（万元）', dataIndex: 'insuranceAmount', width: 150, align: 'right', ellipsis: true,
            render(value: any, record: any, index: any) {
                return (parseFloat(value) ?? 0).toFixed(2);
            }
        },
        { key: 'remark', title: '备注', dataIndex: 'remark', width: 180, ellipsis: true },
        {
            title: '操作', width: 80, ellipsis: true, align: 'center', fixed: 'right',
            render(value: any, record: any, index: any) {
                var configs: IButtonConfig[] = [
                    { name: '详情', onClick: () => { onEdit(record, index, 2); }, hidden: viewMode != 2 },
                    { name: '编辑', onClick: () => { onEdit(record, index, 1); }, hidden: viewMode == 2 },
                    { name: '复制', onClick: () => { onEdit(record, -1, 1, true); }, hidden: viewMode == 2 },
                    { name: '移除', onClick: () => { onDelete(record, index); }, hidden: viewMode == 2, danger: true },
                ];
                return EUtils.InitButtons(configs);
            }
        }];

    useEffect(() => {
        if (data) {
            setDataSource(data ?? []);
        }
    }, [data])

    const onDelete = (record: any, index: number) => {
        confirm({
            title: '移除产品报价',
            icon: <ExclamationCircleFilled />,
            content: '营业额[' + record.Revenue + ']，确认要删除，一旦删除将不能恢复，请慎重操作',
            okText: '确定',
            cancelText: '取消',
            onOk() {
                var newdata = [...dataSource];
                newdata.splice(index, 1);
                setDataSource(newdata);
                message.success('移除成功');
            },
            onCancel() {
            },
        });
    };

    const onEdit = (record: any, index: number, viewMode: number, isCopy: boolean = false) => {
        setEditRecord({
            viewMode: viewMode,
            record: record,
            index: index,
        })
        refComparisonProductPriceEdit.current.setVisible(true);
    }

    return <>
        <div className="group"><LineOutlined rotate={90} style={{ color: '#1890ff' }} />
            {'产品报价'}
        </div>
        <div style={{ margin: '5px' }}>
            <div style={{ backgroundColor: '#fafafa', border: '1px solid #e7e7eb', borderBottom: 'none', padding: '5px' }}>
                <span style={{ lineHeight: '32px', margin: '5px', fontWeight: 'bold' }}></span>
                <Space style={{ float: 'right' }}>
                    <Button type="primary" disabled={viewMode == 2} onClick={() => {
                        onEdit(null, -1, 0);
                        refComparisonProductPriceEdit.current.setVisible(true);
                    }}>添加报价</Button>
                </Space>
            </div>
            <Table size="small" bordered columns={columns} dataSource={dataSource}
                pagination={false}
                scroll={dataSource?.length > 0 ?
                    { x: 'max-content', y: '420px' } : { x: 'max-content' }}
                summary={(pageData) => {
                    let total = {
                        singleLimit: 0,
                        insuranceAmount: 0
                    };
                    pageData.forEach(({ singleLimit, insuranceAmount }) => {
                        total.singleLimit += parseFloat(singleLimit) ?? 0;
                        total.insuranceAmount += parseFloat(insuranceAmount) ?? 0;
                    });

                    return <Table.Summary fixed>
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0}>{'合计：' + pageData.length}</Table.Summary.Cell>
                            <Table.Summary.Cell index={1} colSpan={1} align={'right'}>{total.singleLimit}</Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={1} align={'right'}>{total.insuranceAmount.toFixed(2)}</Table.Summary.Cell>
                            <Table.Summary.Cell index={3} colSpan={1}></Table.Summary.Cell>
                            <Table.Summary.Cell index={4} colSpan={1}></Table.Summary.Cell>
                        </Table.Summary.Row>
                    </Table.Summary>
                }} />
        </div>
        <ComparisonProductPriceEdit ref={refComparisonProductPriceEdit} viewMode={viewMode} {...editRecord}
            dataSource={dataSource}
            onOK={function (record: any): void {
                var data = [...dataSource ?? []];
                if (record.index >= 0) {
                    data.splice(record.index, 1, record);
                } else {
                    data = [
                        ...dataSource ?? [],
                        {
                            ...record,
                            index: dataSource.length
                        }
                    ]
                }
                setDataSource([...data]);
            }} />
    </>;
});
export default ComparisonProductPrice;